var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.newMessages)?_c('v-alert',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",attrs:{"color":"accent","dense":"","text":"","border":"left","icon":"mdi-message-alert-outline"},on:{"click":_vm.goToChats}},[_vm._v(" "+_vm._s(_vm.$t('common.no_read_messages'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }